/**
 * @author Fernando Ruano
 * @file actions.js
 * @description Auth Actions
 */

// Constants
import {
  LOG_IN,
  VERIFY_AUTH,
  SIGN_OUT,
  RESET_PASSWORD,
  RESET_PASSWORD_REGISTER,
  RECOVER_PASSWORD,
  GET_CLAIMS,
  GET_USER_LIST,
  SEND_CODE,
  VERIFY_CODE,
  GET_TOKEN,
  AUTO_ENROLL_FACTOR,
  ACTIVATE_PATIENT_BY_REGISTER
} from './constants';

/**
 * Call process to authenticate user
 * @param  { object } data - Authentication data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of LOG_IN
 */
export const logIn = (data, callback) => ({
  type: LOG_IN,
  payload: { data },
  callback
});

/**
 * Call process to reset user password
 * @param  { object } data - New password data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of LOG_IN
 */
export const resetPassword = (data, callback) => ({
  type: RESET_PASSWORD,
  payload: { data },
  callback
});

/**
 * Call process to reset user password in register mode
 * @param  { object } data - New password data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of LOG_IN for register mode
 */
export const passwordResetRegister = (data, callback) => ({
  type: RESET_PASSWORD_REGISTER,
  payload: { data },
  callback
});

/**
 * Call process to reset user password in register mode
 * @param  { object } data - New password data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of LOG_IN for register mode
 */
export const activatePatientByRegister = (data, callback) => {
  return {
    type: ACTIVATE_PATIENT_BY_REGISTER,
    payload: { data },
    callback
  };
};

/**
 * Call process to recover user password
 * @param  { object } data - password recovery data
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of RECOVER_PASSWORD
 */
export const recoverPassword = (data, callback) => ({
  type: RECOVER_PASSWORD,
  payload: { data },
  callback
});

/**
 * Call process to start validate session
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of VERIFY_AUTH
 */
export const verifyAuth = (callback) => ({
  type: VERIFY_AUTH,
  callback
});

/**
 * Call process to sign out in cognito
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of SIGN_OUT
 */
export const signOut = (data, callback) => ({
  type: SIGN_OUT,
  payload: { data },
  callback
});

/**
 * Call process allow reset user password
 * @param  { object } data - user token
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_CLAIMS
 */
export const getClaims = (data, callback) => ({
  type: GET_CLAIMS,
  payload: { data },
  callback
});

/**
 * Call process get user list by filter
 * @param  { object } data - provider and filter
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_USER_LIST
 */
export const getUserList = (data, callback) => ({
  type: GET_USER_LIST,
  payload: { data },
  callback
});

/**
 * Call process get user list by filter
 * @param  { object } data - provider and filter
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of SEND_CODE
 */
export const sendCode = (data, callback) => ({
  type: SEND_CODE,
  payload: { data },
  callback
});

/**
 * Call process get user list by filter
 * @param  { object } data - provider and filter
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of VERIFY_CODE
 */
export const verifyCode = (data, callback) => ({
  type: VERIFY_CODE,
  payload: { data },
  callback
});

/**
 * Call process get user list by filter
 * @param  { object } data - provider and filter
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of GET_TOKEN
 */
export const getToken = (data, callback) => ({
  type: GET_TOKEN,
  payload: { data },
  callback
});

/**
 * Call process to auto enroll factors
 * @param  { object } data - provider and filter
 * @param  { function } callback - Response callback
 * @return { object } An action object with a type of AUTO_ENROLL_FACTOR
 */
export const autoEnrollFactor = (data, callback) => ({
  type: AUTO_ENROLL_FACTOR,
  payload: { data },
  callback
});
